// Initiall had for multiple same name keys using the same translation
// const getTranslationKey = (key) => key.replace(/[0-9]/g, '')
const getTranslationKey = (key) => key//key.replace(/[0-9]/g, '')

export { getTranslationKey }
